module.exports = __webpack_public_path__ + "img/init_example_program.25df7d2d.png";